import { render } from "./AddColisPage.vue?vue&type=template&id=e32296b4&ts=true"
import script from "./AddColisPage.vue?vue&type=script&lang=ts"
export * from "./AddColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__